const GetTagByType = {
  methods: {
    getTagByType(type, scoped = true) {
      if (scoped === true) {
        return this.item.tags.filter((item) => item.type === type)
      } else {
        return this.tags.filter((item) => item.type === type)
      }
    },
  },
  computed: {
    tags() {
      return this.$store.state.tags.list
    },
  },
}

export default GetTagByType
